import apiClient from 'apiClient';
import { FILTER_NAMES } from '../types';

export const getFirmsData = async (params: Record<string, any>, filter?: string) => {
  if (filter && filter !== FILTER_NAMES.ALL) {
    const response = await apiClient.get(`/api/v1/broker-management/firms/${filter}/`, { params });
    return response.data;
  } else {
    const response = await apiClient.get(`/api/v1/broker-management/firms/`, { params });
    return response.data;
  }
};
